const isProduction = process.env.NODE_ENV === "production";

export type IResponse<Data = any> = {
    code: number;
    msg: string;
    devMsg?: string;
    data?: Data;
};

export class Response<Data = any> implements IResponse<Data> {
    static readonly CODE_EXCEPTION = -1;
    static readonly CODE_SUCCESS = 0;
    static readonly CODE_NOT_SUPPORT_LANG = 2;
    static readonly CODE_SENTENCE_TOO_LONG = 22;
    static readonly CODE_SMART_ORIGINAL_TIME_OUT = 4;
    static readonly CODE_LOGIN_TIME_OUT = 14;

    static readonly MSG_SERVER_EXCEPTION: "服务繁忙，可稍后再尝试或联系客服";
    static readonly MSG_REQUEST_TIME_OUT: "请求超时，请重试";
    static readonly MSG_NETWORK_EXCEPTION: "网络错误，检查网络状态后重试";
    static readonly MSG_APP_EXCEPTION: "发生错误，可尝试刷新页面或联系客服";

    code!: number;
    msg!: string;
    devMsg?: string;
    data?: Data;

    constructor(response: IResponse<Data>) {
        Object.assign(this, response);
    }

    isSuccess() {
        return this.code === Response.CODE_SUCCESS;
    }

    get userMsg(): string {
        return isProduction
            ? this.msg || Response.MSG_SERVER_EXCEPTION
            : this.devMsg ? JSON.stringify(this.devMsg) : `devMsg为空（msg为：${this.msg}）`;
    }

    static newForException<Data = any>(
        msg: string,
        devMsg: string = msg
    ): Response<Data> {
        return new Response<Data>({ code: this.CODE_EXCEPTION, msg, devMsg });
    }
}
